import React from "react";
import styles from "./NotificationMessage.module.scss";
import classNames from "classnames";

type Props = {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler;
  className?: string;
  /** Pass "status" to have screen readers announce the message when it appears. */
  role?: string;
};

const NotificationMessage = ({ children, onClick, className, role }: Props) => {
  return (
    <div
      className={classNames(styles.NotificationMessage, className)}
      onClick={onClick}
      role={role}
    >
      {children}
    </div>
  );
};

export default NotificationMessage;
